var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"load-more-button robotoR",attrs:{"role":"button"},on:{"click":_vm.data.on.click}},[_c('div',{staticClass:"plus-more-text-div"},[_c('span',{staticClass:"plus-more-text-span"},[_vm._t("default")],2),_c('span',{staticClass:"blue-triangle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }